import React from "react";
import ColorInit from "../../../shared/layout/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Header from "../../../shared/layout/Header";
import Footer from "../../../shared/layout/Footer";
import { CartProvider } from "../../cart/context/CartContext";
import RegisteredCheckout from "../components/RegisteredCheckout";
import BottomFooter from "../../../shared/layout/BottomFooter";
const RegisteredCheckoutPage = () => {
  return (
    <CartProvider>
      <ScrollToTop smooth color="#ef253c" />
      <ColorInit color={"bigmall"} />

      <Header />
      <div className="container container-lg">
        <RegisteredCheckout />
      </div>

      <Footer />
      <BottomFooter />
    </CartProvider>
  );
};

export default RegisteredCheckoutPage;
